import React, { useEffect } from 'react'
import { OnboardingType } from 'generated/types'
import CenteredSpinner from 'components/CenteredSpinner/CenteredSpinner'
import { withFlowRouter, WithFlowRouterProps } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'
import { useOnboardingRequirements } from 'utils/FlowProvider/requirementsMapping'

const EarlyOnboarding = ({ route }: WithFlowRouterProps) => {
  const { allOnboardingRequirements, isOnboardingRequirementsLoading } = useOnboardingRequirements(
    OnboardingType.EARLY,
  )

  useEffect(() => {
    if (isOnboardingRequirementsLoading) return

    const state = {
      allOnboardingRequirements,
    }

    route({ from: FlowRoute.Welcome, action: 'continue', state, locationState: state })
  }, [allOnboardingRequirements, isOnboardingRequirementsLoading, route])

  return <CenteredSpinner />
}

export const EarlyOnboardingWelcome = withFlowRouter<{}>(EarlyOnboarding as any)
